import { BFILogoHorizontal } from '@assets/images/svg';
import React, { ReactNode } from 'react';

export interface AuthGateShellProps {
  children: ReactNode;
}

const AuthGateShell = ({ children }: AuthGateShellProps) => (
  <div className="flex flex-col w-full h-screen">
    <div className="bg-white sm:rounded-none h-[67px] sm:h-[77px] fixed w-full z-50 shadow-[0_1px_4px_rgba(0,0,0,0.08)]">
      <img
        src={BFILogoHorizontal}
        alt="BFILogoHorizontal"
        width={123}
        height={35}
        className="h-full m-auto"
      />
    </div>
    <div className="flex flex-col h-full pt-[67px] sm:pt-[77px]">
      <div className="flex flex-col h-full px-5 sm:px-0 sm:mx-10 sm:mt-[69px] sm:rounded-t-lg bg-white items-center">
        {children}
      </div>
    </div>
  </div>
);

export default AuthGateShell;
